/*
 * sp-reveal.js — entrada al aparecer de las secciones de la ficha (kit Shopify maker, 2026-10-17: sp-pains, sp-versus,
 * sp-ideal; CONTRACTS §C).
 *
 * Cada [data-sp-reveal] es un bloque que entra una vez cuando llega a la pantalla: el JS le pone is-armed (el CSS de la
 * sección lo deja transparente y un poco más abajo) y, con un solo IntersectionObserver para toda la página, is-in (el CSS
 * hace la transición de opacity y transform, escalonada con --i en los hijos). Reglas del catálogo de secciones:
 *   - sólo opacity y transform (en el CSS), nada que mueva el layout: sin CLS;
 *   - sin requestAnimationFrame ni listeners de scroll o de gesto: lo mira el navegador (IntersectionObserver);
 *   - un bloque que ya se ve cuando corre el script no se arma (no parpadea): queda como lo dibujó el Liquid;
 *   - prefers-reduced-motion: reduce, sin IntersectionObserver o sin JS → todo visible desde el principio;
 *   - editor de temas: shopify:section:load arma la sección nueva y shopify:section:unload deja de mirar la vieja.
 * window.spReveal = { init(scope), destroy(scope) }.
 */
(function () {
  'use strict';
  if (window.spReveal && window.spReveal.__kit) return;

  var SEL = '[data-sp-reveal]';
  var io = null;
  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function show(el) {
    el.classList.add('is-in');
    if (io) io.unobserve(el);
  }

  function observer() {
    if (io || typeof IntersectionObserver !== 'function') return io;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) show(entries[i].target);
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    return io;
  }

  function listIn(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document;
    var out = [];
    if (root.nodeType === 1 && root.matches(SEL)) out.push(root);
    var found = root.querySelectorAll(SEL);
    for (var i = 0; i < found.length; i++) out.push(found[i]);
    return out;
  }

  function init(scope) {
    if (reduced || !observer()) return;
    var list = listIn(scope);
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.classList.contains('is-armed')) continue;
      // ya en pantalla (o arriba): queda como está, sin armar
      if (el.getBoundingClientRect().top < vh * 0.88) continue;
      el.classList.add('is-armed');
      io.observe(el);
    }
  }

  function destroy(scope) {
    var list = listIn(scope);
    for (var i = 0; i < list.length; i++) {
      if (io) io.unobserve(list[i]);
      list[i].classList.remove('is-armed');
      list[i].classList.remove('is-in');
    }
  }

  window.spReveal = { __kit: 1, init: init, destroy: destroy };

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
